// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropzone {\n  border: 2px dashed black;\n  justify-content: center; align-items: center; display: flex;\n  padding: 20px;\n  height: 100px;\n  text-align: center;\n}\n.dragging-over {\n    border-color: red;\n}\n", ""]);
// Exports
module.exports = exports;
